export type LocationSnapshot = Pick<Location, 'pathname' | 'search' | 'hash'>;

export type TenantSwitchDestination = {
  href: string;
  replace: boolean;
};

export const TENANT_SWITCH_EVENT = 'pal:tenant-switch';

export type TenantSwitchEventDetail = {
  proceed: () => void;
};

// La mayoría de las rutas son vistas de lista o configuración: la misma URL es
// válida para cualquier tenant y conserva pestañas/filtros. Los editores por ID
// no lo son; ese recurso pertenece al tenant anterior y se reemplazan por su
// vista de origen para no abrir un 404 ni un recurso ajeno.
export function resolveTenantSwitchDestination(location: LocationSnapshot): TenantSwitchDestination {
  const pathname = location.pathname || '/';
  const normalizedPath = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;

  if (normalizedPath === '/editor/header' || normalizedPath === '/editor/footer') {
    return { href: '/site?tab=apariencia', replace: true };
  }
  if (/^\/editor\/[^/]+$/.test(normalizedPath)) {
    return { href: '/site?tab=paginas', replace: true };
  }
  if (/^\/surveys\/[^/]+$/.test(normalizedPath)) {
    return { href: '/surveys', replace: true };
  }

  return { href: `${pathname}${location.search}${location.hash}`, replace: false };
}
